import React from "react";
import PageLooper from "./components/PageLooper";

const App: React.FC = () => {
  return <PageLooper />;
};

export default App;
